import { post } from '@classic/Foundation/Services/ApiService'
import { queryClient } from '@core/Data/ReactQuery'
import { throwApiError } from '../Helpers/utils'
import { MfaAuthRequestData, MfaAuthenticateWithMfaRequestData } from '@mobi/api-types'
import { invalidateCognitoUserQuery } from '@core/Data/Account/useCognitoUser'

export async function triggerNonBlockingCognitoContactSync(accountNumber: number) {
  try {
    await syncMfaContact(accountNumber)
  } catch {
    // ... no-op - ignore errors
  }
  return Promise.resolve()
}

async function syncMfaContact(accountNumber: number) {
  try {
    const response = await post<void>({
      url: '/api/bet-account/mfa/sync-contact-details',
      body: { accountNumber },
    })

    invalidateCognitoUserQuery(queryClient)

    return response
  } catch (error: unknown) {
    return throwApiError(error)
  }
}

export type SimpleAuthenticationResponse = {
  IsSuccessful: boolean
  MustCompleteMfaChallenge: undefined | false
}

// the casing on these types is incorrect because
// we want to it match the AuthenticationController
// for easier migration later
export type AuthenticationResponse = {
  IsSuccessful: boolean
  MustCompleteMfaChallenge: true
  mfaSessionId: string
  mfaFactor: 'SMS' | 'EMAIL'
  mfaHint: string
}

export async function authenticateWithMfa(
  body: MfaAuthRequestData | MfaAuthenticateWithMfaRequestData
): Promise<SimpleAuthenticationResponse | AuthenticationResponse> {
  const url =
    'mfaCode' in body && body.mfaCode ? '/api/mfa/authenticate-with-mfa' : '/api/mfa/authenticate'
  try {
    return await post<SimpleAuthenticationResponse | AuthenticationResponse>({
      url,
      body,
    })
  } catch (error: unknown) {
    return throwApiError(error)
  }
}
